export * from './WindowTabsPanel';
